import React from 'react';
import { ComparisonEntry, ComparisonSection } from '../../types/apiDiff';
import StatusBadge from './StatusBadge';
import './CompareVersions.css';

interface ComparisonSectionViewProps {
    section: ComparisonSection;
}

const EntryRow: React.FC<{ entry: ComparisonEntry }> = ({ entry }) => (
    <li className="compare-entry-row" data-testid={`compare-entry-${entry.id}`}>
        <div className="compare-entry-header">
            <StatusBadge status={entry.status} />
            <span className="compare-entry-title">{entry.title}</span>
        </div>
        {entry.from !== undefined && entry.to !== undefined && (
            <div className="compare-entry-values">
                <span className="compare-entry-from">From: {entry.from || '\u2014'}</span>
                <span className="compare-entry-arrow">&rarr;</span>
                <span className="compare-entry-to">To: {entry.to || '\u2014'}</span>
            </div>
        )}
        {entry.detail && <p className="compare-entry-detail">{entry.detail}</p>}
        {entry.changes && entry.changes.length > 0 && (
            <ul className="compare-entry-changes">
                {entry.changes.map((change, index) => (
                    <li key={index}>{change}</li>
                ))}
            </ul>
        )}
    </li>
);

const ComparisonSectionView: React.FC<ComparisonSectionViewProps> = ({ section }) => {
    if (section.entries.length === 0) {
        return (
            <section className="compare-section" aria-label={section.label}>
                <h3 className="compare-section-title">{section.label}</h3>
                <p className="compare-section-empty">No matching {section.label.toLowerCase()} changes.</p>
            </section>
        );
    }

    return (
        <section className="compare-section" aria-label={section.label}>
            <h3 className="compare-section-title">{section.label} ({section.entries.length})</h3>
            <ul className="compare-entry-list">
                {section.entries.map((entry) => (
                    <EntryRow key={entry.id} entry={entry} />
                ))}
            </ul>
        </section>
    );
};

export default ComparisonSectionView;
